<template>
  <button class="btn btn-link mb-2" type="button" @click="onClick">
    <i class="bi bi-file-earmark-arrow-down" /> {{ $t("exportar") }}
  </button>
</template>

<script>
import { getAllParceirosData } from '../parceiroService.js';

export default {
  props: {
    headers: { type: Array, required: true },
    sort: { type: String, required: true },
    order: { type: String, required: true },
    lastLoginInitialDate: { type: String, default: '' },
    lastLoginEndDate: { type: String, default: '' },
    search: { type: String, default: '' },
  },
  methods: {
    async onClick() {
      const header = this.headers;
      if (header.length > 4) {
        header.pop();
      }
      const rows = await getAllParceirosData(this.$props);
      rows.unshift(header);
      const content = 'data:text/csv;charset=utf-8,\ufeff' + rows.map((e) => e.join(';')).join('\n');
      const encodedUri = encodeURI(content);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'parceiros.csv');
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>
